import { Box, Typography, Card, CardContent, Grid, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { useState } from "react";
import welcomeImage2 from "../../Images/backgrounds/welcome-bg.svg";
import PlanDetails from "../Account-setting/modal/PlanDetails";
function WelcomeCard() {
  const [openPlan, setPlanOpen] = useState(false);
  const handlePlanOpen = () => setPlanOpen(true);
  const handlePlanClose = () => setPlanOpen(false);
  const { userData } = useSelector(state => state.reducer);
  const theme = useTheme();
  const btnGroup = {
    display: "flex",
    gap: "20px",
    mt: "20px",
    "& .purchase-plan": {
      backgroundColor: theme.palette.primary.main,
      fontWeight: 700,
      color: "#fff",
      padding: { xs: "10px 20px", sm: "10px 35px" },
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: "8px",
      transition: "0.3s all",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
        color: "#fff",
      },
      "&:focus": {
        outline: "none",
      },
    },
  };
  return (
    <Card elevation={0} sx={{ backgroundColor: theme.palette.primary.light, py: 0 }}>
      <CardContent sx={{ py: 4, px: 2 }}>
        <Grid container justifyContent="space-between">
          <Grid item sm={6} display="flex" alignItems="center">
            <Box
              gap="16px"
              sx={{
                display: {
                  xs: "block",
                },
                alignItems: "center",
              }}
            >
              <Box>
                <Typography variant="h5" sx={{ whiteSpace: { xs: "wrap", sm: "nowrap" }, fontSize: { xs: "20px", sm: "28px" }, fontWeight: "700", mb: "8px" }}>
                  Current Plan:{" "}
                  <Typography
                    component="span"
                    sx={{ whiteSpace: { xs: "wrap", sm: "nowrap" }, fontSize: { xs: "20px", sm: "28px" }, fontWeight: "700", mb: "12px", color: theme.palette.primary.main }}
                  >
                    {userData?.subscriptionCredits?.subscriptionType || ""}
                  </Typography>
                </Typography>
                <Typography component="p" sx={{ fontSize: "14px", fontWeight: "500" }}>
                  Enjoy the benefits and tools available with your selected plan.
                </Typography>
              </Box>
              <Box sx={btnGroup}>
                <button type="button" className="purchase-plan" onClick={handlePlanOpen} onFocus={e => e.target.blur()}>
                  View Plan Details
                </button>
                <PlanDetails handleClose={handlePlanClose} open={openPlan} viewDetails={null} />
              </Box>
            </Box>
          </Grid>
          <Grid item sm={6}>
            <Box mb="-24px" textAlign="right">
              <Typography component="img" src={welcomeImage2} alt="img" sx={{ width: "250px", height: "auto" }} />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default WelcomeCard;
